import type { InvoiceLineItemRecord } from '@shared/types';

function roundCurrency(value: number): number {
  return Math.round(value * 100) / 100;
}

export function calculateInvoiceLineTotal(quantity: number, unitPrice: number): number {
  return roundCurrency(quantity * unitPrice);
}

export function calculateInvoiceTaxAmount(lineTotal: number, vatRate: number): number {
  return roundCurrency((lineTotal * vatRate) / 100);
}

export function calculateInvoiceTotals(lineItems: InvoiceLineItemRecord[]) {
  return lineItems.reduce(
    (totals, item) => {
      const subtotal = totals.subtotal + item.lineTotal;
      const taxTotal = totals.taxTotal + calculateInvoiceTaxAmount(item.lineTotal, item.vatRate);

      return {
        subtotal: roundCurrency(subtotal),
        taxTotal: roundCurrency(taxTotal),
        grandTotal: roundCurrency(subtotal + taxTotal)
      };
    },
    {
      subtotal: 0,
      taxTotal: 0,
      grandTotal: 0
    }
  );
}

export function formatInvoiceReference(series: string, number: string): string {
  return `${series} ${number}`.trim();
}
